<ng-template #buttonContent>
  @if (buttonIconPath()) {
    <img [src]="buttonIconPath()" />
  }
  {{ buttonTextLabelPath() | labelsProvider }}
</ng-template>

<div class="app-button">
  @if (isEnabled()) {
    <button class="confirm" [class.uppercase]="isUppercase()" type="submit" (click)="handleClick($event)">
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  } @else if (disabledTooltipText() && tooltipPosition()) {
    <button
      class="confirm confirm-disabled disabled"
      type="submit"
      [matTooltip]="disabledTooltipText()"
      matTooltipClass="tooltip-container"
      [matTooltipPosition]="tooltipPosition()"
      tooltip="tooltip"
    >
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  } @else {
    <button class="confirm confirm-disabled disabled" type="submit">
      <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
    </button>
  }
</div>
